// removed by extract-text-webpack-plugin
module.exports = {"root":"_AO4Xv","info":"_1L3XC","content":"_3BtkL","date":"_JMjpY","qrcode":"_1rUpt","mobileLink":"_1Z7D1","text":"_1GqQI","avatar":"_3VR5O","avatarImage":"_3YdXH"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/AuthorBlock/AuthorBlock.scss
// module id = 1160
// module chunks = 2